import './styles/index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import throttle from 'lodash/throttle';
import mixin from 'lodash/mixin';
import _ from 'lodash/wrapperLodash';
import { staticContentFetchData } from './redux/actions';
import { breakpoints } from './styles/theme.json';

mixin(_, {
  throttle: throttle
});

// REDUX
import { Provider } from 'react-redux';
import configureStore from './redux/store/configureStore';
import { setScrollState, setResizeState } from './redux/actions';

const store = configureStore();
const API = process.env.API_URL;
store.dispatch(staticContentFetchData(API + 'main'));

const resizeHandler = () => {
  store.dispatch(setResizeState());
};
const scrollHandler = () => {
  store.dispatch(setScrollState());
};
// INITIALIZE
resizeHandler();
scrollHandler();
// ADD EVENT LISTENERS
window.addEventListener('resize', _.throttle(resizeHandler, 75));

if (store.getState().window_dimensions.window_width >= breakpoints.desktop) {
  window.addEventListener('wheel', _.throttle(scrollHandler, 100));
} else {
  window.addEventListener('scroll', _.throttle(scrollHandler, 100));
}

ReactDOM.render(
  <Provider store={store}>
  	<App/>
  </Provider>, document.getElementById('root')
);

console.log('BW2020');


// WEBPACK FOOTER //
// ./src/index.js